import styled from 'styled-components';
import { useTranslation } from '@hooks';

import { useFilter } from '@context/FilterContext';
import { CloseIcon } from '@components/icons';
import { FilterAccordion } from '@components/listing';
import { Text2 } from '@components/styles/Typography';
import { NewButton } from '@components/ui';

const FilterMenu = ({ filters, onModalClose, productCount }) => {
    const { locale, t } = useTranslation();
    const { onClearAllFilters, selectedFilterCount } = useFilter();

    const applyFilters = () => {
        onModalClose();
    };

    return (
        <FilterMenuWrapper>
            <FilterMenuHeader>
                <Text2>{`${t('filter')} (${selectedFilterCount.all})`}</Text2>
                <button onClick={onModalClose} type="button">
                    <CloseIcon width="12px" height="12px" />
                </button>
            </FilterMenuHeader>
            <FiltersWrapper>
                {filters.map((filter) => (
                    <FilterAccordion
                        key={filter.id}
                        locale={locale}
                        filterData={filter}
                        initalState={filter.slug.en === 'price' && true}
                        selectedFilterCount={
                            selectedFilterCount[filter.slug.en]
                        }
                    />
                ))}
            </FiltersWrapper>

            <ButtonsWrapper>
                <NewButton
                    size="xlarge"
                    type="primary"
                    content={`${t('applyFilters')} (${productCount})`}
                    handleClick={applyFilters}
                />
                <NewButton
                    size="xlarge"
                    type="secondary"
                    content={t('clearFilters')}
                    handleClick={onClearAllFilters}
                />
            </ButtonsWrapper>
        </FilterMenuWrapper>
    );
};
const FilterMenuWrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    padding: 20px;
    overflow-y: scroll;
    position: relative;
`;
const FiltersWrapper = styled.div`
    margin-top: 43px;
    height: 75%;
    overflow-y: scroll;
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
    ::-webkit-scrollbar {
        display: none;
    }
`;
const FilterMenuHeader = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    padding: 0 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 59px;
    box-shadow: 0 3px 6px 0 rgba(40, 49, 59, 0.06);
    button {
        background: transparent;
        border: none;
        outline: none;
        padding: 0 2px;
        cursor: pointer;
    }
`;

const ButtonsWrapper = styled.div`
    position: absolute;
    top: 80%;
    left: 0;
    width: 100%;
    padding: 0 20px;
    button {
        margin-top: 10px;
    }

    @media (max-width: 1024px) {
        padding: 0;
        @supports (-webkit-touch-callout: none) {
            top: 70%;
        }
    }
`;

export default FilterMenu;
